import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { getPaymentStatus, redsysReturn } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");
  const { clear } = useCart();

  useEffect(() => {
    if (!sid) { setState("error"); return undefined; }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        if (tries === 0 && params.get("Ds_MerchantParameters")) {
          await redsysReturn({ Ds_SignatureVersion: params.get("Ds_SignatureVersion"), Ds_MerchantParameters: params.get("Ds_MerchantParameters"), Ds_Signature: params.get("Ds_Signature") }).catch(() => {});
        }
        const r = await getPaymentStatus(sid);
        if (r?.payment_status === "paid") { setState("paid"); clear(); return; }
        if (r?.status === "expired" || r?.payment_status === "failed") { setState("error"); return; }
      } catch { /* retry */ }
      if (++tries >= 10) { setState("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid, clear, params]);

  return (
    <main data-testid="payment-success-page" className="min-h-[100svh] grid place-items-center px-5 pt-24">
      <div className="max-w-xl text-center">
        {state === "checking" && <><Loader2 className="w-10 h-10 mx-auto animate-spin text-[#8CD05A]" /><p className="font-serif-d text-4xl mt-6">Confirmando tu pago…</p></>}
        {state === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 mx-auto text-[#8CD05A]" />
            <h1 data-testid="payment-success-title" className="font-serif-d font-light text-5xl md:text-6xl mt-6">Pedido <span className="italic text-[#F2B441]">confirmado.</span></h1>
            <p className="text-[#C9D6C2] mt-4">Gracias por confiar en Jungle Nutrient. Recibirás la confirmación por correo electrónico.</p>
          </>
        )}
        {(state === "error" || state === "timeout") && (
          <>
            <XCircle className="w-12 h-12 mx-auto text-[#F2B441]" />
            <h1 data-testid="payment-error-title" className="font-serif-d text-5xl mt-6">{state === "timeout" ? "Aún procesando" : "Pago no completado"}</h1>
            <p className="text-[#C9D6C2] mt-4">{state === "timeout" ? "Revisa tu correo en unos minutos." : "No se ha realizado ningún cargo."}</p>
          </>
        )}
        <Link to="/" data-testid="back-home-link" className="inline-flex mt-10 rounded-full border border-[#8CD05A]/40 px-7 h-12 items-center hover:border-[#F2B441] hover:text-[#F2B441] transition-colors">Volver a la tienda</Link>
      </div>
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="min-h-[100svh] grid place-items-center px-5 pt-24">
      <div className="max-w-xl text-center">
        <h1 className="font-serif-d font-light text-5xl md:text-6xl">Pago <span className="italic text-[#F2B441]">cancelado.</span></h1>
        <p className="text-[#C9D6C2] mt-4">Tu carrito sigue guardado. Puedes completar la compra cuando quieras.</p>
        <Link to="/" data-testid="cancel-back-home-link" className="inline-flex mt-10 rounded-full bg-[#8CD05A] text-[#0E2A1C] font-semibold px-7 h-12 items-center hover:bg-[#F2B441] transition-colors">Volver a la tienda</Link>
      </div>
    </main>
  );
}
